import { Stack } from '@chakra-ui/react';

import { ListingFiltersSkeletonDesktopCheckboxGroup } from './listing-filters-skeleton-desktop-checkbox-group';
import { ListingFiltersSkeletonDesktopRangeSlider } from './listing-filters-skeleton-desktop-range-slider';
import { ListingFiltersSkeletonDesktopReservationSwitch } from './listing-filters-skeleton-desktop-reservation-switch';

export const ListingFiltersSkeletonDesktop = () => (
    <Stack gap={8}>
        <ListingFiltersSkeletonDesktopReservationSwitch />
        <ListingFiltersSkeletonDesktopCheckboxGroup itemsCount={3} />
        <ListingFiltersSkeletonDesktopRangeSlider />
        <ListingFiltersSkeletonDesktopCheckboxGroup itemsCount={6} withShowMore />
        <ListingFiltersSkeletonDesktopCheckboxGroup itemsCount={4} />
        <ListingFiltersSkeletonDesktopCheckboxGroup itemsCount={11} />
        <ListingFiltersSkeletonDesktopCheckboxGroup itemsCount={5} />
    </Stack>
);
